import {entry, objectFromEntries} from '@benchling/js-utils';
import React from 'react';

import {ArchiveRecord} from 'archive/ArchiveConstants';
import ArchiveRecordLabel from 'archive/components/ArchiveRecordLabel';
import isArchived from 'archive/isArchived';
import BenchlingConfig from 'BenchlingConfig';
import {schemaFieldsetNamePluralized} from 'schemas/schema-interface/util/schemaFieldsetName';
import EditableItemTable, {RowProps} from 'ui-library/EditableItemTable';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import APIUtil, {apiIdToIconName} from 'util/APIUtil';
import {capitalize, typeToName} from 'util/NameUtil';
import strUtil from 'util/strUtil';
interface RelatedSchemaOrInterface {
  id: string;
  name: string;
  archiveRecord?: ArchiveRecord | null;
}

export interface RelatedSchemasTableProps {
  schemas: Array<RelatedSchemaOrInterface>;
}

export default function RelatedSchemasTable({schemas}: RelatedSchemasTableProps): JSX.Element {
  const configAwareSchemasAndFieldsets = BenchlingConfig.SCHEMAS_ENABLE_INTERFACES
    ? `schemas and ${schemaFieldsetNamePluralized()}`
    : 'schemas';
  const columnHeaders = [
    {
      name: strUtil.toSentenceCase(configAwareSchemasAndFieldsets),
      width: 8,
    },
    {name: 'Type', width: 4},
  ];

  // have to cast mapping function output because typescript treats [s.id, i] as ReactText[]
  const schemaIndicesById = objectFromEntries(schemas.map((schema, i) => entry(schema.id, i)));

  const mapSchemaToRowValue = (schema: RelatedSchemaOrInterface): Array<JSX.Element | string> => [
    <div>
      <BenchlingIcon className="typeIcon u-small-spacing-left" icon={apiIdToIconName(schema.id)} />
      <span className="u-small-spacing-left">
        {schema.name}
        <ArchiveRecordLabel item={schema} />
      </span>
    </div>,
    capitalize(typeToName(APIUtil.apiIdToType(schema.id))),
  ];

  const rows: Array<RowProps> = schemas.map((schema: RelatedSchemaOrInterface) => {
    const row: RowProps = {
      id: schema.id,
      itemIndex: schemaIndicesById[schema.id],
      isArchived: isArchived(schema),
      values: mapSchemaToRowValue(schema),
    };
    return row;
  });
  return (
    <div className="settingsPage-contentWrapper">
      <div className="u-large-spacing-bottom">
        <p>{`This dropdown is being used in the following ${configAwareSchemasAndFieldsets}:`}</p>
      </div>
      <EditableItemTable
        columnHeaders={columnHeaders}
        emptyMessage={`There are no accessible ${configAwareSchemasAndFieldsets} using this dropdown.`}
        rows={rows}
        isLoading={false}
        getEditUrl={(itemIndex) => null}
        writable={false}
        leftSubheaderNode={null}
      />
    </div>
  );
}
